import Grid from '@material-ui/core/Grid'
import { CrudForm, Snackbar, TextField, useEntityManager } from 'elentari'
import React, { useState } from 'react'
import { Field } from 'react-final-form'
import { useHistory } from 'react-router-dom'
import * as yup from 'yup'
import yupValidation from '../../lib/yupValidation'
import { restApi } from '../../services/Api'
import configuracoesRepository from './ConfiguracoesRepository'
import { Warning } from './Warning'

const configuracoesSchema = yup.object().shape({
  valor: yup
    .string()
    .trim()
    .required('Obrigatório')
})

export const validate = yupValidation(configuracoesSchema)

const ConfiguracoesForm = props => {
  const [mensagem, setMessage] = useState('')
  const [submitStatus, setSubmitStatus] = useState('edit')
  const [submitting, setSubmitting] = useState(false)
  const history = useHistory()
  const entityManager = useEntityManager({
    repository: configuracoesRepository
  })
  const handleSubmit = async data => {
    data.valor = data.valor.toString()
    setSubmitting(true)
    const response = await restApi.patch(`configuracoes/${data.chave}`, data)
    if (response.ok) {
      setSubmitStatus('success')
      history.replace(
        history.location.pathname.replace(/new$|new-child$/, data.chave)
      )
      setMessage(`${data.chave} atualizado com sucesso!`)
    } else {
      setSubmitStatus('error')
      setMessage(
        `${response?.data?.error?.message || `Erro ao atualizar ${data.chave}`}`
      )
    }
    setSubmitting(false)
  }
  return (
    <>
      <CrudForm
        {...props}
        {...entityManager}
        status={submitStatus}
        submitting={submitting}
        onSubmit={handleSubmit}
        validate={validate}
        withPaper
      >
        <Grid container spacing={2}>
          <Grid item sm={6} xs={12}>
            <Field
              fullWidth
              disabled
              name="chave"
              label="Chave"
              component={TextField}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <Field fullWidth name="valor" label="Valor" component={TextField} />
            <Warning chave={entityManager.item?.chave}/>
          </Grid>
        </Grid>
      </CrudForm>
      <Snackbar
        autoHideDuration={6000}
        message={mensagem}
        onClose={() => {
          setMessage('')
          setSubmitStatus('edit')
        }}
      />
    </>
  )
}

export default ConfiguracoesForm
